import { useState, useEffect } from "react";
import uuid from "uuid";

const useExternalScriptLoader = src => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!document && !document.body) {
      return;
    }

    const id = `useExternalScriptLoader-${uuid()}`;
    const script = document.createElement("script");

    script.src = src;
    script.id = id;

    script.onload = () => {
      setLoaded(true);
    };

    script.onerror = () => {
      setError(true);
    };

    document.body.appendChild(script);

    return () => {
      const scriptEl = document.getElementById(id);

      if (scriptEl) {
        scriptEl.remove();
      }
    };
  }, [src]);

  return [loaded, error];
};

export default useExternalScriptLoader;
